import React from "react";
import WhiteBgCard from "./WhiteBgCard";

const CommonCardLayout = ({ children, title = "", headerRight }) => {
  return (
    <div className="flex flex-col gap-3.5">
      <div className="flex items-center justify-between">
        <h3 className="text-[0.85rem] font-bold text-gray-800 font-inter">
          {title}
        </h3>
        {headerRight}
      </div>
      <WhiteBgCard>{children}</WhiteBgCard>
    </div>
  );
};

export default CommonCardLayout;
